module.exports = __webpack_public_path__ + "img/ring_g_e_null_1@2x.67ae3a04.png";